import { createBatch, createFlushController, createHttpRequest, createIdentityEncoder } from '@datadog/browser-core';
export function startLogsBatch(configuration, lifeCycle, reportError, pageMayExitObservable, session) {
  var endpoints = [configuration.logsEndpointBuilder];

  if (configuration.replica) {
    endpoints.push(configuration.replica.logsEndpointBuilder);
  }

  var batch = createBatch({
    encoder: createIdentityEncoder(),
    request: createHttpRequest(endpoints, configuration.batchBytesLimit, reportError),
    flushController: createFlushController({
      messagesLimit: configuration.batchMessagesLimit,
      bytesLimit: configuration.batchBytesLimit,
      durationLimit: configuration.flushTimeout,
      pageMayExitObservable: pageMayExitObservable,
      sessionExpireObservable: session.expireObservable
    }),
    messageBytesLimit: configuration.messageBytesLimit
  });
  lifeCycle.subscribe(1
  /* LifeCycleEventType.LOG_COLLECTED */
  , function (serverLogsEvent) {
    batch.add(serverLogsEvent);
  });
  return batch;
}